import {ResultContainer} from "./ResultContainer";
import {ResultKicker} from "./ResultKicker";
import {MainMatchCard} from "./MainMatchCard";
import {ResultPageContainer} from "./ResultPageContainer";
import {useQuizState} from "../quiz/quizContext";
import {MatchImage} from "./MatchImage";
import {MatchContent} from "./MatchContent";
import {LesserMatch} from "./LesserMatch";
import {LesserMatchContent} from "./LesserMatchContent";
import {Typography} from "../typography/Typography";
import {MatchBar} from "./MatchBar";
import {useAppTranslation} from "../app/appContext";

export const ResultsPage = () => {
    const t = useAppTranslation();
    const {quiz} = useQuizState();
    const answersIds = (quiz?.questions || []).map(question => question.selectedAnswerUniqueId);

    const profileWithMatch = (quiz?.profiles || []).map(profile => {
        const distances = (profile.responses || [])
            .filter(response => (quiz?.questions || []).find(question => question.uniqueId === response.questionId && question.active))
            .map(response => {
                const question = (quiz?.questions || []).find(q => q.uniqueId === response.questionId);
                const answer = question?.answers?.find(a => answersIds.includes(a.uniqueId));
                return euclideanDistance(
                    response.likertScore,
                    answer ? answer.likertScore : 0
                );
            });

        return {
            ...profile,
            percentage: matchPercent(averageDistance(distances))
        };
    }).sort((a, b) => b.percentage - a.percentage);

    const [bestMatch, ...rest] = profileWithMatch;

    if (!bestMatch) {
        return (
            <ResultPageContainer>
                <div role="status">
                    {t('noProfilesFound', "Ingen resultatprofiler funnet")}
                </div>
            </ResultPageContainer>
        );
    }

    return (
        <ResultPageContainer>
            <ResultContainer>
                <ResultKicker
                    text={quiz?.spectrum?.resultPrefix || t('bestMatchTitle', "Du er nærmest...")}
                />
                <MainMatchCard
                    title={bestMatch.title}
                >
                    <MatchImage
                        media={bestMatch.media}
                    />
                    <Typography
                        tag={"h2"}
                        size={"xl"}
                    >
                        {Math.round(bestMatch.percentage)}% {t('match', "match")}
                    </Typography>
                    <MatchBar percentage={`${Math.round(bestMatch.percentage)}%`}/>
                    <MatchContent text={bestMatch.details} />
                </MainMatchCard>
                <ResultKicker
                    text={t('lesserMatchTitle', "Slik matcher du med andre profiler:")}
                />
                {rest.map(profile => (
                    <LesserMatch
                        key={profile.uniqueId}
                    >
                        <MatchImage
                            media={profile.media}
                        />
                        <LesserMatchContent
                            title={profile.title}
                            text={profile.details}
                            percentageMatch={profile.percentage}
                        />
                    </LesserMatch>
                ))}
            </ResultContainer>
        </ResultPageContainer>
    );
};

const euclideanDistance = (a, b) => Math.sqrt(Math.pow((a || 0) - (b || 0), 2));

const averageDistance = (distances) => {
    if (!distances || distances.length === 0) {
        return 0;
    }
    return distances.reduce((a, b) => a + b, 0) / distances.length;
};

const matchPercent = (avgDistance) => ((4 - avgDistance) / 4) * 100;
